import { COUNTRY_SHORTCODES } from '../constants'

export const shouldSetupPaymentAccountAtOrientation = country => {
  const countryMap = new Set([COUNTRY_SHORTCODES.NZ])
  const countryNeedsPaymentAccountSetup = countryMap.has(country)
  return countryNeedsPaymentAccountSetup
}
